var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6366 13.6364C5.75629 13.8436 5.92843 14.0158 6.13572 14.1354C6.34301 14.2551 6.57815 14.3181 6.81751 14.3181C7.05686 14.3181 7.292 14.2551 7.4993 14.1354C7.70659 14.0158 7.87873 13.8436 7.99842 13.6364M0.859789 9.76774C0.770719 9.86536 0.711939 9.98676 0.6906 10.1172C0.66926 10.2476 0.686279 10.3814 0.739589 10.5023C0.792898 10.6232 0.880199 10.7261 0.990872 10.7983C1.10154 10.8705 1.23082 10.909 1.36297 10.9091H12.272C12.4042 10.9091 12.5335 10.8708 12.6442 10.7987C12.755 10.7266 12.8424 10.6239 12.8958 10.5031C12.9493 10.3822 12.9665 10.2485 12.9453 10.118C12.9241 9.98762 12.8655 9.86615 12.7766 9.76842C11.8698 8.83364 10.9084 7.84024 10.9084 4.77274C10.9084 3.68777 10.4774 2.64723 9.71021 1.88004C8.94302 1.11284 7.90248 0.681838 6.81751 0.681838C5.73253 0.681838 4.692 1.11284 3.9248 1.88004C3.15761 2.64723 2.7266 3.68777 2.7266 4.77274C2.7266 7.84024 1.76456 8.83365 0.859789 9.76774Z",
    stroke: "currentColor",
    strokeWidth: 1.36363,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.f0b2adb7.svg";
export { ForwardRef as ReactComponent };